import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Hero from '../components/Hero';
import UseCases from '../components/UseCases';
import Title from '../assets/Title.png';
import './Home.css';

const Home = () => {
  return (
    <motion.div
      className="page home-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <header className="header">
        <Link to="/" className="logo">
          <img src={Title} alt="Unscramble Logo" className="logo-image" />
        </Link>
        <Link to="/history" className="nav-link">
          Past Rambles
        </Link>
      </header>

      <main className="home-main">
        <Hero />
        <UseCases />
      </main>
    </motion.div>
  );
};

export default Home;
